<template>
  <div>
    <div class="flex items-center justify-between mb-3">
      <h4 class="text-sm font-semibold text-slate-900">发布者信息</h4>
      <button
        v-permission="'app:circle:publisher:manage'"
        type="button"
        title="管理官方发布者"
        aria-label="管理官方发布者"
        class="w-8 h-8 flex items-center justify-center rounded-md text-slate-400 hover:text-primary-500 hover:bg-primary-50 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300"
        @click="$emit('manage')"
      >
        <el-icon :size="16"><Setting /></el-icon>
      </button>
    </div>

    <div v-if="loading" class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-2">
      <div
        v-for="index in 5"
        :key="index"
        class="min-h-[72px] rounded-lg border border-slate-200 bg-slate-50 animate-pulse"
      ></div>
    </div>

    <div
      v-else-if="publishers.length > 0"
      class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-2"
    >
      <button
        v-for="publisher in publishers"
        :key="publisher.id"
        type="button"
        :aria-pressed="publisher.id === selectedId"
        :title="publisher.nickname"
        class="relative flex min-h-[72px] flex-col items-center justify-center gap-1.5 rounded-lg border px-2 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300"
        :class="publisher.id === selectedId
          ? 'border-primary-500 bg-primary-50'
          : 'border-slate-200 bg-white hover:border-primary-300 hover:bg-slate-50'"
        @click="$emit('select', publisher)"
      >
        <img
          :src="publisher.avatarUrl"
          :alt="publisher.nickname"
          class="h-8 w-8 rounded-full object-cover"
        />
        <span class="w-full truncate text-center text-xs text-slate-700" :title="publisher.nickname">
          {{ publisher.nickname }}
        </span>
        <el-icon
          v-if="publisher.id === selectedId"
          :size="12"
          class="absolute right-1 top-1 text-primary-500"
        >
          <Check />
        </el-icon>
      </button>
    </div>
  </div>
</template>

<script setup>
import { Check, Setting } from '@element-plus/icons-vue'

defineProps({
  publishers: { type: Array, default: () => [] },
  selectedId: { type: [Number, String], default: null },
  loading: { type: Boolean, default: false }
})

defineEmits(['select', 'manage'])
</script>
